import * as React from 'react';
import { connect } from 'react-redux';
import { assign } from '../../shared/Assign';
import { Translate } from '../../shared/LanguageService';
import { handleError } from '../../shared/ErrorCatching';
import CommonTextForm from './CommonTextForm';
import { Modal, Button } from 'react-bootstrap';
import { create } from './Actions';
import ICommonTextInput from './ICommonTextInput';
import notify from '../../shared/feedback/notifications';
import FormInputChangeHandler from '../../shared/form/FormInputChangeHandler';

export class CommonTextModal extends React.Component<any, any> {
    formInputChangeHandler: FormInputChangeHandler;

    constructor(props: any) {
        super(props);

        this.state = {
            input: { text: '' },
            errors: {},
            creating: false
        };

        this.save = this.save.bind(this);
        this.create = this.create.bind(this);
        this.setValue = this.setValue.bind(this);
        this.formInputChangeHandler = new FormInputChangeHandler(this.state.input, this.setValue);
    }

    setValue(newState: any) {
        this.setState({ input: newState });
    }

    save(e: React.FormEvent): void {
        e.preventDefault();
        this.setState({ creating: true });
        if (this.props.editId === -1) {
            this.create();
        }
    }

    create(): void {
        this.props.actions
            .create(this.state.input)
            .then(() => {
                this.setState({ creating: false });
                this.props.closeModal();
                notify.success(Translate('common-texts/notification/common-text-added'));
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors, creating: false });
                })
            );
    }

    render() {
        return (
            <div>
                <Modal show={this.props.shouldShowModal} onHide={this.props.closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {Translate('common-texts/modal/title/add-common-text')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <CommonTextForm
                            input={this.state.input}
                            onChange={this.formInputChangeHandler.onChange}
                            errors={this.state.errors}
                            save={this.save}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.props.closeModal}>
                            {Translate('common-texts/modal/footer/button-label/close')}
                        </Button>
                        <Button
                            disabled={this.state.creating}
                            bsStyle="primary"
                            onClick={this.save}
                        >
                            {Translate('common-texts/modal/footer/button-label/save')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any): any {
    return {};
}

function mapDispatchToProps(dispatch: any): any {
    return {
        actions: {
            create: (input: ICommonTextInput) => dispatch(create(input))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CommonTextModal);
